/**
 * Profile Types - derived from id_user_profile_types_view
 *
 * These correspond to the `type_of_profile` column computed from
 * the profile's STI type and their representations.
 */

export const PROFILE_TYPES = {
  MEDIA: "type_media",
  PROMOTER_PR: "type_promoter_pr",
  PROMOTER_EXPERT: "type_promoter_expert",
  PROMOTER_HYBRID: "type_promoter_hybrid",
};

// Inbox "Role" filter values → the counterpart profile types they match. Shared by the
// conversations and pitches list queries so the two filters can never drift apart.
export const ROLE_PROFILE_TYPES = {
  experts: [PROFILE_TYPES.PROMOTER_EXPERT, PROFILE_TYPES.PROMOTER_HYBRID],
  prs: [PROFILE_TYPES.PROMOTER_PR],
  media: [PROFILE_TYPES.MEDIA],
};

export const isMedia = (type) => type === PROFILE_TYPES.MEDIA;

export const isPromoterPr = (type) => type === PROFILE_TYPES.PROMOTER_PR;

export const isPromoterExpert = (type) => type === PROFILE_TYPES.PROMOTER_EXPERT;

export const isPromoterHybrid = (type) => type === PROFILE_TYPES.PROMOTER_HYBRID;

export const isExpertProfile = (type) =>
  type === PROFILE_TYPES.PROMOTER_EXPERT || type === PROFILE_TYPES.PROMOTER_HYBRID;
